import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { api } from '@consts/url.const';
import { ShelfsModel } from '@models/shelfs.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShelfsService {

  constructor(
    private http: HttpClient,
  ) { }

  public getShelfs(page: number, pageSize: number, filters: ShelfsModel.Filters): Observable<{ data: ShelfsModel.ShelfDocument[] }> {
    let url = api.shelfs.crud;

    let params = new HttpParams();

    if (page) {
      params = params.set('page', page);
    }

    if (pageSize) {
      params = params.set('pageSize', pageSize);
    }

    if (filters?.name?.length) {
      params = params.set('name', filters.name);
    }

    if (filters?.cameraIdsExcludes?.length) {
      params = params.set('cameraIdsExcludes', filters.cameraIdsExcludes);
    }

    if (filters?.cameraIdsIncludes?.length) {
      params = params.set('cameraIdsIncludes', filters.cameraIdsIncludes);
    }

    if (filters?.tagIds?.length) {
      params = params.set('tagIds', filters.tagIds);
    }

    return this.http.get<{ data: ShelfsModel.ShelfDocument[] }>(url, { params });
  }

  public getDetailsById(id: string): Observable<ShelfsModel.ShelfDocument> {
    let url = api.shelfs.delailsById(id);
    return this.http.get<ShelfsModel.ShelfDocument>(url);
  }

  public edit(id: string, dto: Partial<ShelfsModel.ShelfCreateDto>): Observable<ShelfsModel.ShelfDocument> {
    let url = api.shelfs.byId(id);
    return this.http.put<ShelfsModel.ShelfDocument>(url, dto);
  }

  public delete(id: string): Observable<ShelfsModel.ShelfDocument> {
    let url = api.shelfs.byId(id);
    return this.http.delete<ShelfsModel.ShelfDocument>(url);
  }

  public createShelf(dto: ShelfsModel.ShelfCreateDto): Observable<ShelfsModel.ShelfDocument> {
    let url = api.shelfs.crud;

    return this.http.post<ShelfsModel.ShelfDocument>(url, dto);
  }
}
